(function(){
  'use strict';

  var ROOT_SELECTOR='.nuvio-variant-collection[data-filter-match-field="variant_title"]';
  var productCache={};
  var originalState=new WeakMap();
  var activeRun=new WeakMap();

  function normalise(value){
    return String(value||'')
      .toLowerCase()
      .replace(/matt\b/g,'matte')
      .replace(/gun\s+metal/g,'gunmetal')
      .replace(/[^a-z0-9]+/g,' ')
      .replace(/\s+/g,' ')
      .trim();
  }

  function productPath(card){
    var raw=card.getAttribute('data-product-url')||'';
    if(!raw){
      var link=card.querySelector('a[href*="/products/"]');
      raw=link?link.getAttribute('href')||'':'';
    }
    try{return new URL(raw,location.origin).pathname.replace(/\/$/,'');}
    catch(error){return raw.split('?')[0].replace(/\/$/,'');}
  }

  function getProduct(card){
    var path=productPath(card);
    if(!path) return Promise.reject(new Error('Missing product path'));
    if(!productCache[path]){
      productCache[path]=fetch(path+'.js',{headers:{Accept:'application/json'}})
        .then(function(response){
          if(!response.ok) throw new Error('Product data unavailable');
          return response.json();
        });
    }
    return productCache[path];
  }

  function finishSpec(button){
    var labelEl=button.querySelector('.nv-vc-filter-label');
    var label=normalise(labelEl?labelEl.textContent:button.textContent);
    var raw=normalise(button.getAttribute('data-filter-value')||'');
    var spec={label:label,aliases:[],exclude:[]};

    if(label.indexOf('light brushed brass')!==-1){
      spec.aliases=['light brushed brass'];
    }else if(label.indexOf('matte black')!==-1 || label==='black'){
      spec.aliases=['matte black','black'];
    }else if(label.indexOf('brushed gold')!==-1 || label==='gold'){
      spec.aliases=['brushed gold','gold','brushed brass'];
      spec.exclude=['light brushed brass'];
    }else if(label.indexOf('brushed nickel')!==-1 || label==='nickel'){
      spec.aliases=['brushed nickel','nickel'];
    }else if(label.indexOf('brushed copper')!==-1 || label==='copper'){
      spec.aliases=['brushed copper','copper'];
    }else if(label.indexOf('gunmetal')!==-1){
      spec.aliases=['gunmetal'];
    }else if(label.indexOf('chrome')!==-1){
      spec.aliases=['chrome'];
    }else{
      spec.aliases=raw.split(',').map(normalise).filter(Boolean);
      if(!spec.aliases.length&&label) spec.aliases=[label];
    }
    return spec;
  }

  function matchesFinish(value,spec){
    var text=normalise(value);
    if(!text) return false;
    for(var i=0;i<spec.exclude.length;i++){
      if(text.indexOf(spec.exclude[i])!==-1) return false;
    }
    for(var j=0;j<spec.aliases.length;j++){
      var alias=spec.aliases[j];
      if(text===alias || text.indexOf(alias)!==-1) return true;
    }
    return false;
  }

  function optionName(option){
    return normalise(typeof option==='string'?option:(option&&option.name));
  }

  function finishOptionIndex(product){
    var options=product.options||[];
    for(var i=0;i<options.length;i++){
      var name=optionName(options[i]);
      if(name==='finish'||name==='colour'||name==='color'||name.indexOf('finish')!==-1||name.indexOf('colour')!==-1||name.indexOf('color')!==-1){
        return i;
      }
    }
    return -1;
  }

  function findFinishVariant(product,spec){
    var variants=product.variants||[];
    var finishIndex=finishOptionIndex(product);
    var ordered=variants.filter(function(v){return v.available;}).concat(variants.filter(function(v){return !v.available;}));
    for(var i=0;i<ordered.length;i++){
      var variant=ordered[i];
      var options=variant.options||[];
      var value=finishIndex>=0?options[finishIndex]:options.join(' | ')+' | '+(variant.title||'');
      if(matchesFinish(value,spec)) return variant;
    }
    return null;
  }

  function imageSource(image){
    if(!image) return '';
    if(typeof image==='string') return image;
    return image.src||image.url||'';
  }

  function money(cents){
    var amount=Number(cents||0);
    if(window.Shopify&&typeof window.Shopify.formatMoney==='function'){
      try{
        var format=(window.theme&&window.theme.moneyFormat)||(window.Shopify&&window.Shopify.money_format)||'${{amount}}';
        return window.Shopify.formatMoney(amount,format);
      }catch(error){}
    }
    var currency=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'AUD';
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-AU',{style:'currency',currency:currency}).format(amount/100);}
    catch(error){return '$'+(amount/100).toFixed(2);}
  }

  function remember(card){
    if(originalState.has(card)) return;
    var img=card.querySelector('[data-card-img]');
    var link=card.querySelector('[data-card-link]');
    var price=card.querySelector('[data-card-price]');
    var badges=card.querySelector('[data-card-badges]');
    var input=card.querySelector('[data-variant-input]');
    var button=card.querySelector('[data-atc-button]');
    var sizes=card.querySelector('[data-size-pills]');
    originalState.set(card,{
      imgSrc:img?img.getAttribute('src'):null,
      imgSrcset:img?img.getAttribute('srcset'):null,
      imgAlt:img?img.getAttribute('alt'):null,
      linkHref:link?link.getAttribute('href'):null,
      priceHtml:price?price.innerHTML:null,
      badgesHtml:badges?badges.innerHTML:null,
      inputValue:input?input.value:null,
      buttonDisabled:button?button.disabled:null,
      buttonText:button?button.textContent:null,
      variantTitle:card.getAttribute('data-variant-title'),
      sizesDisplay:sizes?sizes.style.display:null,
      sizesHidden:sizes?sizes.hidden:null
    });
  }

  function restoreCard(card){
    var state=originalState.get(card);
    if(!state) return;
    var img=card.querySelector('[data-card-img]');
    var link=card.querySelector('[data-card-link]');
    var price=card.querySelector('[data-card-price]');
    var badges=card.querySelector('[data-card-badges]');
    var input=card.querySelector('[data-variant-input]');
    var button=card.querySelector('[data-atc-button]');
    var sizes=card.querySelector('[data-size-pills]');
    if(img){
      if(state.imgSrc!==null) img.setAttribute('src',state.imgSrc);
      if(state.imgSrcset!==null) img.setAttribute('srcset',state.imgSrcset); else img.removeAttribute('srcset');
      if(state.imgAlt!==null) img.setAttribute('alt',state.imgAlt);
    }
    if(link&&state.linkHref!==null) link.setAttribute('href',state.linkHref);
    if(price&&state.priceHtml!==null) price.innerHTML=state.priceHtml;
    if(badges&&state.badgesHtml!==null) badges.innerHTML=state.badgesHtml;
    if(input&&state.inputValue!==null) input.value=state.inputValue;
    if(button){button.disabled=!!state.buttonDisabled;if(state.buttonText!==null) button.textContent=state.buttonText;}
    if(state.variantTitle!==null) card.setAttribute('data-variant-title',state.variantTitle); else card.removeAttribute('data-variant-title');
    if(sizes){sizes.style.display=state.sizesDisplay||'';sizes.hidden=!!state.sizesHidden;}
    card.removeAttribute('data-nuvio-finish-match');
    card.classList.remove('is-hidden');
  }

  function applyVariant(card,product,variant){
    remember(card);
    var img=card.querySelector('[data-card-img]');
    var link=card.querySelector('[data-card-link]');
    var price=card.querySelector('[data-card-price]');
    var badges=card.querySelector('[data-card-badges]');
    var input=card.querySelector('[data-variant-input]');
    var button=card.querySelector('[data-atc-button]');
    var sizes=card.querySelector('[data-size-pills]');
    var src=imageSource(variant.featured_image)||imageSource(product.featured_image);
    var compare=Number(variant.compare_at_price||0);
    var current=Number(variant.price||0);
    var onSale=compare>current;

    if(img&&src){
      img.setAttribute('src',src);
      img.removeAttribute('srcset');
      img.setAttribute('alt',(product.title||'Product')+' — '+(variant.title||''));
    }
    if(link) link.setAttribute('href',productPath(card)+'?variant='+variant.id);
    if(price){
      price.innerHTML=onSale
        ? '<span class="nv-vc-price--sale">'+money(current)+'</span> <s>'+money(compare)+'</s>'
        : '<span>'+money(current)+'</span>';
    }
    if(badges){
      badges.innerHTML='';
      if(onSale) badges.innerHTML+='<span class="nv-vc-badge nv-vc-badge--sale">Sale</span>';
      if(!variant.available) badges.innerHTML+='<span class="nv-vc-badge nv-vc-badge--soldout">Sold out</span>';
    }
    if(input) input.value=variant.id;
    if(button){
      button.disabled=!variant.available;
      button.textContent=variant.available?(button.getAttribute('data-label-default')||'Add to cart'):'Sold out';
    }
    if(sizes){sizes.style.display='none';sizes.hidden=true;}
    card.setAttribute('data-variant-title',normalise(variant.title));
    card.setAttribute('data-nuvio-finish-match','true');
    card.classList.remove('is-hidden');
  }

  function updateResults(root,visible){
    var count=root.querySelector('[data-nuvio-result-count]');
    if(count) count.textContent=visible+' '+(visible===1?'product':'products')+' shown';
    var empty=root.querySelector('[data-liveempty],.nv-vc-empty');
    if(empty) empty.classList.toggle('is-visible',visible===0);
  }

  function reset(root){
    activeRun.set(root,{});
    root.removeAttribute('data-nuvio-finish-active');
    root.querySelectorAll('.nv-vc-card').forEach(restoreCard);
    setTimeout(function(){
      var visible=root.querySelectorAll('.nv-vc-card:not(.is-hidden)').length;
      updateResults(root,visible);
    },0);
  }

  function applySelectedFinish(root,button){
    var value=(button.getAttribute('data-filter-value')||'').trim();
    if(!value){reset(root);return;}

    var run={};
    activeRun.set(root,run);
    root.setAttribute('data-nuvio-finish-active','true');
    var spec=finishSpec(button);
    var cards=Array.prototype.slice.call(root.querySelectorAll('.nv-vc-card'));

    Promise.all(cards.map(function(card){
      remember(card);
      return getProduct(card).then(function(product){
        if(activeRun.get(root)!==run) return false;
        var variant=findFinishVariant(product,spec);
        if(!variant){
          card.setAttribute('data-nuvio-finish-match','false');
          card.classList.add('is-hidden');
          return false;
        }
        applyVariant(card,product,variant);
        return true;
      }).catch(function(){
        if(activeRun.get(root)!==run) return false;
        card.setAttribute('data-nuvio-finish-match','false');
        card.classList.add('is-hidden');
        return false;
      });
    })).then(function(results){
      if(activeRun.get(root)!==run) return;
      updateResults(root,results.filter(Boolean).length);
    });
  }

  function activeButton(root){return root.querySelector('.nv-vc-filter.is-active');}

  function bind(root){
    if(root.getAttribute('data-nuvio-finish-fix')==='true') return;
    root.setAttribute('data-nuvio-finish-fix','true');

    root.addEventListener('click',function(event){
      var button=event.target.closest&&event.target.closest('.nv-vc-filter');
      if(!button||!root.contains(button)) return;
      setTimeout(function(){
        var active=activeButton(root)||button;
        applySelectedFinish(root,active);
      },20);
    });

    var grid=root.querySelector('.nv-vc-grid');
    if(grid&&window.MutationObserver){
      var timer=null;
      new MutationObserver(function(){
        var active=activeButton(root);
        if(!active||(active.getAttribute('data-filter-value')||'').trim()==='') return;
        clearTimeout(timer);
        timer=setTimeout(function(){applySelectedFinish(root,active);},40);
      }).observe(grid,{childList:true});
    }
  }

  function boot(scope){
    (scope||document).querySelectorAll(ROOT_SELECTOR).forEach(bind);
  }

  var style=document.createElement('style');
  style.textContent='[data-nuvio-finish-active="true"] .nv-vc-card[data-nuvio-finish-match="false"]{display:none!important}';
  document.head.appendChild(style);

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot(document);});
  else boot(document);
  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
})();
